/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { DataProcessor } from './selectors';

export const COLOUR1 = '#2E9FD6';
export const COLOUR2 = '#32D2D9';
export const COLOUR3 = '#2871C2';
export const COLOUR4 = '#65E6AB';
export const COLOUR5 = '#F4AEA6';

export const totalEmissionsUtrCodes: UtrVariables = ({
  a: { code: 'gri/2020/305-1/a' },
  b: { code: 'gri/2020/305-2/a' },
  c: { code: 'gri/2020/305-2/b' },
  d: { code: 'gri/2020/305-3/a' },
});

export const CHART_DEFAULTS = {
  OPTIONS: {
    colors: [COLOUR1, COLOUR2, COLOUR3, COLOUR4, COLOUR5],
    pieSliceTextStyle: {
      color: '#0c3866',
      fontSize: 8,
    },
    legend: {
      position: 'bottom'
    },
    chartArea: {
      top: 10,
      bottom: 55,
      left: 60,
      right: 10,
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      }
    },
    bar: {
      groupWidth: '50%',
      width: '80%'
    },
  }
};

export interface DataSource {
  width?: number;
  height?: number;
  chart?: string;
};

export interface DataProps {
  data: number[];
};

export interface ChartProps {
  utrCodes: string[];
  data: (string | number | { role: string })[][];
  showNoData: boolean;
  effectiveDate: string | undefined;
  vAxisTitle?: string;
}

export interface GenericChartOptions {
  vAxis?: {
    title?: string;
    format?: string;
  },
  hAxis?: {
    gridlines?: {
      color: string;
    };
    textPosition?: string;
    minValue?: number;
  },
  pieHole?: number;
  pieSliceText?: 'label' | string;
  bar?: {
    groupWidth: string;
    width: string;
  };
  isStacked?: boolean;
  legend?: 'none' | { position: 'none' | 'left' };
  chartArea?: {
    top: number;
    bottom: number;
    left: number;
    right: number;
  }
}
export interface GenericChartProps {
  chartType: 'LineChart' | 'PieChart' | 'ColumnChart' | 'BarChart';
  settingsSelector: string; // using string to be able to store and retrieve from db
  width?: number | string;
  height?: number | string;
  options?: string // GenericChartOptions but using a string reference to store and retrieve from db
  gridSize?: { w: number, h: number };
}

export interface UtrVariable {
  code: string;
  valueListCode?: string;
  groupCode?: string;
  subGroupCode?: string;
}

export interface UtrVariables {
  [key: string]: UtrVariable
}

export interface GenericDataProps {
  variables?: UtrVariables;
  unitText?: string;
  suffix?: string;
  decimalPlaces?: number;
  width?: number | string;
  height?: number | string;
  dataProcessor?: DataProcessor;
}

export enum InsightPage {
  Overview = 'overview',
  Environmental = 'environmental',
  Social = 'social',
  Governance = 'governance',
};

export enum ChartType {
  LineChart = 'LineChart',
  PieChart = 'PieChart',
  ColumnChart = 'ColumnChart',
  BarChart= 'BarChart'
}
